import client from '../../client';

const subaccountDeactivate = async (userId: string): Promise<void> => {
  // userId comes back as '{domain}/{email}', but we need '{email}' only
  userId = userId.split('/').pop() || userId;
  const { data } = await client.get<void>('/subaccount/deactivate', {
    params: { userId },
  });

  return data;
};

export default subaccountDeactivate;
